import { render, staticRenderFns } from "./StatusDropdown.vue?vue&type=template&id=1060f320&"
import script from "./StatusDropdown.vue?vue&type=script&lang=js&"
export * from "./StatusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports